import { createSelector } from 'reselect';

const publishSettingsState = (state) => state.publicSettings;

export const getPublishState = createSelector(publishSettingsState, (publishSettings) => publishSettings?.publish);

export const getFetchState = createSelector(publishSettingsState, (publishSettings) => publishSettings?.fetch);

export const getUpdateState = createSelector(publishSettingsState, (publishSettings) => publishSettings?.update);
